<template>
  <div class='table-box'>
    <global-tag>
      <el-form label-width='90px' ref='form' :model='form'>
        <el-row>
          <el-col :span='5'>
            <el-form-item label='接收机构：'>
              <el-cascader
                v-model='receiveOrg'
                ref='receiveOrg'
                :options='quyuList'
                :show-all-levels='false'
                :props='{ checkStrictly: true,emitPath: false,label: "label",value:"orgId" }'
                clearable>
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span='3' offset='1'>
            <el-button type='primary' class='searchBtns' @click='getTable'
            >查询
            </el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div v-if='!levelStatus'>
      <el-table
        :data='tableData1'
        border
        style='width: 100%'
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"

      >
        <el-table-column
          type='index'
          width='70'
          label='序号'
          align='center'
          :show-overflow-tooltip='true'
        ></el-table-column>
        <el-table-column
          prop='serveNum'
          label='派发批次'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='pgdNum'
          label='工单总量'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>

        <el-table-column
          prop='receiveOrgName'
          label='接收机构'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='disOrgName'
          label='派发机构'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='completeTime'
          label='完成时间'
          align='center'
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          prop='pgdNumActual'
          label='进度'
          align='center'
          :show-overflow-tooltip='true'
        >
          <template slot-scope='scope'>
            {{ scope.row.pgdNumActual }}/{{ scope.row.pgdNum }}
          </template>
        </el-table-column>

        <el-table-column
          label='操作'
          align='center'
          :show-overflow-tooltip='true'
        >
          <template slot-scope='scope'>
            <el-button
              type='text'
              @click='handleShow(scope.row)'
            >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class='pagination_container' v-if='!levelStatus'>
      <el-pagination
        :page-sizes='[10, 20, 50, 100]'
        :page-size='pageSize'
        :current-page.sync='pageNo'
        layout='total, sizes, prev, pager, next, jumper'
        :total='total'
        @size-change='handletableDataSize'
        @current-change='handleTableDataChange'
      ></el-pagination>
    </div>
    <!-- 查看 -->
    <el-dialog
      title=''
      :visible.sync='centerDialogVisible'
      width='80%'
      center>
      <div>
        <div class='searchBox'>
          <QueryForm
            @QuerySearch='QuerySearch'
            :queryForm='queryForm'
          ></QueryForm>
        </div>
        <!-- 表格 -->
        <div>
          <el-table
            :data='tableData'
            border
            style='width: 100%'
            :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
          >
            <el-table-column
              fixed='left'
              type='index'
              width='70'
              label='序号'
              align='center'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='orderNum'
              label='工单流水号'
              align='center'
              width='220'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='customerName'
              label='客户姓名'
              align='center'
              width='180'
              :show-overflow-tooltip='true'
            >
            </el-table-column>

            <el-table-column
              prop='customerphone'
              label='联系方式'
              align='center'
              width='150'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='address'
              label='居住地址'
              align='center'
              width='220'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='servetypename'
              label='服务类别'
              align='center'
              width='180'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='timeStart'
              label='服务开始时间'
              align='center'
              width='220'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='timeEnd'
              label='服务结束时间'
              align='center'
              width='220'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='realPeriod'
              label='时间工作时间/分钟'
              align='center'
              width='180'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              prop='estimateLevel'
              :formatter='estimateLevelFormat'
              label='客户满意度'
              align='center'
              width='120'
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              fixed='right'
              prop='states'
              label='状态'
              align='center'
              :show-overflow-tooltip='true'
              width='150'
            >
              <template slot-scope='scope'>
                <span v-if='scope.row.states == 2' style='color:red;'>未回访</span>
                <span v-if='scope.row.states == 3' style='color:green;'>
                                     {{ scope.row.flage == 1 ? '服务完成(质检)' : '服务完成' }}
                                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style='height: 20px'></div>
        <div>
          <el-pagination
            @size-change='handleSizeChange'
            @current-change='handleCurrentChange'
            :page-sizes='[5, 20, 30, 40]'
            :page-size='query.pageSize'
            layout='total, sizes, prev, pager, next, jumper'
            :total='totalCount'
          >
          </el-pagination>
        </div>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span> -->
    </el-dialog>
    <!-- 暂无权限派发 -->
    <div style='
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 50vh;' v-if='levelStatus'>
      <el-link type='danger' :underline='false'>当前账号暂无权限操作！</el-link>
    </div>
  </div>
</template>

<script>
import qualityManageDetail from './qualityManageDetail'
import headLine from '../components/headline'
import QueryForm from '@/component/queryform.vue'

export default {
  components: {
    headLine,
    qualityManageDetail,
    QueryForm
  },
  mounted() {
    this.getTree()
    this.getTable() //主体表格数据
  },
  watch: {
    'receiveOrg'() {
      if (this.$refs.receiveOrg) {
        this.$refs.receiveOrg.dropDownVisible = false //监听值发生变化就关闭它
      }
    }
  },
  data() {
    return {
      queryForm: {
        serveManagementId: '',
        customerName: '',
        customerType: '',
        serveproductName: '',
        servestationName: '',
        servePersonName: '',
        timeStart: '',
        timeEnd: ''
      },
      query: {
        pageNum: 1,
        pageSize: 5
      },
      totalCount: 0,
      form: {
        type: ''
      },
      centerDialogVisible: false,
      receiveOrg: '',
      levelStatus: false,
      quyuList: [],
      tableData: [],
      tableData1: [],
      pageSize: 10,
      total: 0,
      pageNo: 1,
      isSearchContent: true
    }
  },
  methods: {
    // 获取组织树
    getTree() {
      this.$post('/rbac/admin/org/info/OrgTreelist', { isValid: 1 }).then(
        (res) => {
          if (res.code === 200) {
            //当前账号绑定的机构所有下级
            let treeList = []
            this.quyuList = this.chbehavior(res.content, this.$store.state.info.orgId)
            let orgLevel = this.getorgLevel(res.content, this.$store.state.info.orgId)
            if (orgLevel == 0 || orgLevel == 1 || orgLevel == 2) { //当前机构等级不是总公司、省级、市级 就没有派发权限
              this.levelStatus = false
            } else {
              this.levelStatus = true
            }

            if (!this.quyuList.children) { //当前账号绑定的机构下级&自己数据
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId
              })
              this.quyuList = treeList
            } else {
              treeList.push({
                label: this.quyuList.label,
                orgId: this.quyuList.orgId,
                children: this.quyuList.children
              })
              this.quyuList = treeList
            }

          }
        }
      )
    },
    chbehavior(arr, id) {
      let res;
      (function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a
          } else if (a.children && !res) {
            deepId(a.children, id)
          }
        }
      })(arr, id)
      return res
    },
    //获取当前机构等级
    getorgLevel(arr, id) {
      let res;
      (function deepId(arr, id) {
        for (let a of arr) {
          if (a.orgId == id) {
            res = a.orgLevel
          } else if (a.children && !res) {
            deepId(a.children, id)
          }

        }

      })(arr, id)
      return res
    },
    getTable() {
      this.$http.request({
        url: '/jjyl//admin/serviceManagement/info/findList',
        method: 'POST',
        data: {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          receiveOrgId: this.receiveOrg
        }
      }).then((res) => {
        if (res.code === 200) {
          if (res.content && res.content.list) {
            this.tableData1 = res.content.list
            this.total = res.content.count
          } else {
            // this.$message.warning('暂无数据~')
            this.tableData1 = []
            this.total = 0
          }
        }
      })
    },

    Reset() {
      this.receiveOrg = ''
      this.getTable()
    },
    // 分页切换
    handletableDataSize(val) {
      this.pageSize = val
      this.getTable()
    },
    // 分页切换
    handleTableDataChange(val) {
      this.pageNo = val
      this.getTable()
    },

    // 弹窗数据==========================================================================

    //查看弹窗
    handleShow(date) {
      this.centerDialogVisible = true
      this.serveManagementId = date.id
      this.getlist(this.serveManagementId)
    },
    //获取弹框内表格数据列表
    getlist(id) {
      this.$http.request({
        url: '/jjyl/admin/serviceManagement/info/findServicepgd',
        method: 'POST',
        data: {
          pageNo: this.query.pageNum,
          pageSize: this.query.pageSize,
          serveManagementId: id,
          customerName: this.queryForm.customerName,
          customerType: this.queryForm.customerType,
          serveproductName: this.queryForm.serveproductName,
          servestationName: this.queryForm.servestationName,
          servePersonName: this.queryForm.servePersonName,
          timeStart: this.queryForm.timeStart,
          timeEnd: this.queryForm.timeEnd
        }
      }).then((res) => {
        if (res.code === 200) {
          if (res.content && res.content.list) {
            this.tableData = res.content.list
            this.totalCount = res.content.count
          } else {
            this.$message.warning('暂无数据！')
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    estimateLevelFormat(row, column) {
      if (row.estimateLevel === '1') {
        return '一星'
      } else if (row.estimateLevel === '2') {
        return '二星'
      } else if (row.estimateLevel === '3') {
        return '三星'
      } else if (row.estimateLevel === '4') {
        return '四星'
      } else if (row.estimateLevel === '5') {
        return '五星'
      }
    },
    QuerySearch() {
      this.getlist(this.serveManagementId)
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getlist(this.serveManagementId)
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      this.getlist(this.serveManagementId)
    }
  }
}
</script>

<style>
.QuerySearchBtn {
  margin: 15px 0 !important;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}

.operation-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.operation-color {
  margin-left: 10px;
  margin-right: 10px;
}
</style>
<style lang='less' scoped>
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}

</style>
